var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.5 0C9.57187 0 11.25 1.79 11.25 4C11.25 6.21 9.57187 8 7.5 8C5.42812 8 3.75 6.21 3.75 4C3.75 1.79 5.42812 0 7.5 0ZM7.5 16C7.5 16 15 16 15 14C15 11.6 11.3438 9 7.5 9C3.65625 9 0 11.6 0 14C0 16 7.5 16 7.5 16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInput);
export default __webpack_public_path__ + "static/media/userInput.1df544e18cc2058e10698e1739750634.svg";
export { ForwardRef as ReactComponent };